<template>
    <div id="dropMenu">
        <Dropdown trigger="click" style="margin-left: 10px;" @on-click="onSelect">
            <a href="javascript:void(0)" style="color:white">
                {{this.sta.userId!=""?this.sta.userId:'临时用户',}}
                <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
                <div :key="rid">
                    <div v-for="item in bindDropList" :key="item.name">
                        <DropdownItem v-if="item.name==='007'" :name="item.name" divided>{{item.functionName}}</DropdownItem>
                        <DropdownItem v-else :name="item.name">{{item.functionName}}</DropdownItem>
                    </div>
                </div>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'UserLoginMenu',
    data() {
        return {
            rid: +new Date(),
            //value:sta.userId!=""?sta.userId:'未登录',
            //pwdDisabled:false,
        }
    },
    created() {
        //console.log('===============>',this.sta.wxgenerateid,this.sta.userId,this.sta.wxunionid)
    },
    computed: {
        ...mapGetters(['sta']),

        bindDropList: function() {
            console.log('bindDropList===>')

            //基础功能
            let dropList = [{
                name: '008',
                functionName: '账号中心',
                isShow: true},{
                name: '014',
                functionName: '推广码',
                isShow: true},

                ]
            //是否可以显示绑定手机
            if (!this.sta.mobileNum) {
                let item = {
                    name: '012',
                    functionName: '绑定手机',
                    isShow: true,
                }
                dropList.push(item)
            } else {
                let item = {
                    name: '006',
                    functionName: '更换手机',
                    isShow: true,
                }
                if (this.sta.userId) {
                    let item1 = {
                        name: '001',
                        functionName: '重置密码',
                        isShow: true,
                    }
                    dropList.push(item1)
                }
                dropList.push(item)

            }

            //是否可以显示关联微信
            if (this.sta.wxunionid === '' && this.sta.wxopenid === '') {
                let item = {
                    name: '011',
                    functionName: '关联微信',
                    isShow: true,
                }
                dropList.push(item)
            } else if (this.sta.wxunionid !== '' && this.sta.userId) {
                let item = {
                    name: '013',
                    functionName: '重置微信',
                    isShow: true,
                }
                dropList.push(item)
            }

            //是否可以显示修改密码功能
            if (this.sta.userId) {
                let item = {
                    name: '009',
                    functionName: '修改密码',
                    isShow: true,
                }
                dropList.push(item)
            }

            //是否具有修改账号的功能
            if (this.sta.iseditacc) {
                let item = {
                    name: '010',
                    functionName: '修改账号',
                    isShow: true,
                }
                dropList.push(item)
            }

            let lastItem = {
                name: '007',
                functionName: '退出登录',
                isShow: true
            }
            dropList.push(lastItem)
            return dropList
        }
    },

    methods: {
        ...mapActions(['handleSetUserLogout']),
        // showAuthority() {
        //     console.log('showAuthority======>')
        //     console.log(this.sta)
        //     let accounttype = this.sta.accounttype
        //     if (accounttype === 1 || accounttype === 3) {
        //         let item = this.dropList.find(p => p.name === '008')
        //         item.isShow = false
        //     }
        // },
        refreshDroplist() {
            console.log('refresh user menu==>')
            this.rid = +new Date()
        },
        onSelect(arg) {
            if (arg === "007") {
                this.handleSetUserLogout();
                this.$emit('logout');
            } else if (arg === "001") {
                if (this.sta.userId !== "") {
                    this.$emit('pwdReset')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需修改密码,请退出后重新登录")
                    return
                }
            } else if (arg === "002") {
                this.$emit('showUserinfo')
            } else if (arg === "003") {
                this.$emit('showManagePwd')
            } else if (arg === "004") {
                this.$emit('showpay')
            } else if (arg === "005") {
                if (this.sta.userId !== "") {
                    this.$emit('showvip')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需修改密码,请退出后重新登录")
                    return
                }

            } else if (arg === "008") {
                //我的会员
                this.$router.push({ name: 'vipcenter' })
            } else if (arg === "006") {
                if (this.sta.userId !== "") {
                    this.$emit('showChangePhone')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需修改密码,请退出后重新登录")
                    return
                }

            } else if (arg === "009") {
                if (this.sta.userId !== "") {
                    this.$emit('pwdEdit')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需修改密码,请退出后重新登录")
                    return
                }
            } else if (arg === "010") {
                if (!this.sta.mobileNum) {
                    this.$emit('showBindPhone')
                    this.$Message.warning("修改账号需要验证手机号码，请您先绑定手机号码")
                    return
                }
                if (this.sta.userId !== "") {
                    this.$emit('showSmsEditAcc')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需修改账号,请退出后重新登录")
                    return
                }
            } else if (arg === "011") {
                if (this.sta.userId !== "") {
                    this.$emit('showBindWechat')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需关联微信,请退出后重新登录")
                    return
                }
            }
            //showBindPhone
            else if (arg === "012") {
                if (this.sta.userId !== "") {
                    this.$emit('showBindPhone')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需关联微信,请退出后重新登录")
                    return
                }
            } else if (arg === "013") {
                if (!this.sta.mobileNum) {
                    this.$emit('showBindPhone')
                    this.$Message.warning("重置微信需要验证手机号码，请您先绑定手机号码")
                    return
                }

                if (this.sta.userId !== "") {
                    this.$emit('showResetWxToken')
                } else {
                    this.$Message.warning("您的登录信息已过期,如需关联微信,请退出后重新登录")
                    return
                }
            }else if(arg==='014'){
                 if (this.sta.userId !== "") {
                    this.$emit('show-promo-code')
                }
            }





        }
    },
    watch: {
        loginUserId: function(v) {
            // console.log(this.sta)
            // console.log("loginUserId:"+this.loginUserId)
        }
    }
}
</script>
<style lang="less">
.ivu-select-dropdown {
    max-height: 300px !important;
}
</style>